module.exports = __webpack_public_path__ + "img/Vichida_Vongvanij.2f1045d5.png";